import Vue from 'vue'
import Vuex from 'vuex'

// Modules
import app from './app'
import appConfig from './app-config'
import verticalMenu from './vertical-menu'
import auth from './auth'
import user from './user'
import dealer from './dealer'
import trainingCourse from './trainingCourse'
import certification from './certification'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    app,
    appConfig,
    verticalMenu,
    auth,
    user,
    dealer,
    trainingCourse,
    certification,
  },
  strict: process.env.DEV,
})
